import * as React from 'react';
import { connect } from 'react-redux';
import { handleError } from '../../shared/ErrorCatching';
import { Translate } from '../../shared/LanguageService';
import { SE360 } from '../../shared/Site';
import ReceivableFilter from './filter/ReceivableFilter';
import * as actions from './ReceivableActions';
import { ISelectViewModel, DateType } from './Types';
import ReceivableSummary from './summary/ReceivableSummary';
import ReceivableDetails from './details/ReceivableDetails';
import { Col, Row } from 'react-bootstrap';
import InvoiceTypeLegend from '../invoice/InvoiceTypeLegend';

interface IState {
    fromDate: any;
    toDate: any;
    selectedCustomerId: number;
    selectedCustomer: ISelectViewModel;
    onlyUnsettledInvoices: boolean;
    site: number;
}

class ReceivablePage extends React.Component<any, IState> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            fromDate: new Date(),
            toDate: new Date(),
            selectedCustomerId: 0,
            selectedCustomer: null,
            onlyUnsettledInvoices: false,
            site: SE360
        };

        this.onFromDateChange = this.onFromDateChange.bind(this);
        this.onToDateChange = this.onToDateChange.bind(this);
        this.onCustomerSelected = this.onCustomerSelected.bind(this);
        this.onOnlyUnsettledInvoicesChange = this.onOnlyUnsettledInvoicesChange.bind(this);
        this.show = this.show.bind(this);
        this.onSiteChange = this.onSiteChange.bind(this);

        this.onToDateBlur = this.onToDateBlur.bind(this);
        this.onFromDateBlur = this.onFromDateBlur.bind(this);
    }

    onFromDateChange(e: any): void {
        if (typeof e !== 'string') {
            this.setState({ fromDate: e ? e.toDate() : null } as IState);
            this.props.actions.resetState(this.props.legalEntityId);
        }
    }

    onFromDateBlur(e: any): void {
        if (typeof e !== 'string' && e.isValid()) {
            this.setState({ fromDate: e ? e.toDate() : null } as IState);
            this.props.actions.resetState(this.props.legalEntityId);
        }
    }

    onToDateChange(e: any): void {
        if (typeof e !== 'string') {
            this.setState({ toDate: e ? e.toDate() : null } as IState);
            this.props.actions.resetState(this.props.legalEntityId);
        }
    }

    onToDateBlur(e: any): void {
        if (typeof e !== 'string' && e.isValid()) {
            this.setState({ toDate: this.state.toDate } as IState);
            this.props.actions.resetState(this.props.legalEntityId);
        }
    }

    onCustomerSelected(e: any): void {
        this.setState({
            selectedCustomerId: e.value,
            selectedCustomer: { ...e }
        } as IState);

        this.props.actions.resetState(this.props.legalEntityId);
    }

    onOnlyUnsettledInvoicesChange(e: any): void {
        this.setState({ onlyUnsettledInvoices: e.target.checked } as IState);

        this.props.actions.resetState(this.props.legalEntityId);
    }

    onSiteChange(e: any) {
        this.setState({ site: e.value } as IState);
    }

    show(e: any): void {
        this.props.actions
            .getData(
                this.props.legalEntityId,
                this.state.fromDate,
                this.state.toDate,
                this.state.onlyUnsettledInvoices,
                this.state.selectedCustomerId
            )
            .catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <h1>{Translate('receivable/legend')}</h1>
                <ReceivableFilter
                    fromDate={this.state.fromDate}
                    onFromDateChange={this.onFromDateChange}
                    toDate={this.state.toDate}
                    onToDateChange={this.onToDateChange}
                    selectedCustomer={this.state.selectedCustomer}
                    customers={this.props.customers}
                    onCustomerSelected={this.onCustomerSelected}
                    onlyUnsettledInvoices={this.state.onlyUnsettledInvoices}
                    onOnlyUnsettledInvoicesChange={this.onOnlyUnsettledInvoicesChange}
                    onButtonClick={this.show}
                    onFromDateBlur={this.onFromDateBlur}
                    onToDateBlur={this.onToDateBlur}
                />
                <ReceivableSummary
                    invoicesInvoiced={this.props.invoicesInvoiced}
                    invoicesPaid={this.props.invoicesPaid}
                    invoicesSum={this.props.invoicesSum}
                    creditsInvoiced={this.props.creditsInvoiced}
                    creditsPaid={this.props.creditsPaid}
                    creditsSum={this.props.creditsSum}
                    totalsInvoiced={this.props.totalsInvoiced}
                    totalsPaid={this.props.totalsPaid}
                    totalsSum={this.props.totalsSum}
                    currency={this.props.currency}
                    site={this.props.site}
                />
                <ReceivableDetails
                    currency={this.props.currency}
                    details={this.props.details}
                    site={this.props.site}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    let legalEntity = state.receivable.legalEntities.filter(
        (le) => le.id === ownProps.legalEntityId
    )[0];
    return {
        customers: legalEntity.customers,
        invoicesInvoiced: legalEntity.invoicesInvoiced,
        invoicesPaid: legalEntity.invoicesPaid,
        invoicesSum: legalEntity.invoicesSum,
        creditsInvoiced: legalEntity.creditsInvoiced,
        creditsPaid: legalEntity.creditsPaid,
        creditsSum: legalEntity.creditsSum,
        totalsInvoiced: legalEntity.totalsInvoiced,
        totalsPaid: legalEntity.totalsPaid,
        totalsSum: legalEntity.totalsSum,
        details: legalEntity.details,
        currency: legalEntity.currency,
        site: legalEntity.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getData: (
                legalEntityId: number,
                fromDate: any,
                toDate: any,
                onlyUnsettledInvoices: boolean,
                customer: number
            ) =>
                dispatch(
                    actions.getData(
                        legalEntityId,
                        fromDate,
                        toDate,
                        onlyUnsettledInvoices,
                        customer
                    )
                ),
            resetState: (legalEntityId: number) =>
                dispatch(actions.resetLegalEntityState(legalEntityId))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceivablePage);
